export default "__VITE_PUBLIC_ASSET__d496b501__"